var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[(_vm.url)?_c('img',{attrs:{"src":_vm.url,"alt":"banner图"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }